"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#FBF6F7",
  z100: "#F7EBEC",
  z200: "#FDC9D1",
  z300: "#F8A2B2",
  z400: "#F57082",
  z500: "#ED5A6B",
  z_red: "#E23744",
  z600: "#EC4654",
  z700: "#D02A38",
  z800: "#760A12",
  z900: "#47060B",
  rgb: {
    z100: "254,230,232",
    z200: "253,180,186",
    z300: "252,131,140",
    z400: "242,90,101",
    z500: "226,55,68",
    z600: "212,17,32",
    z700: "165,13,25",
    z800: "118,10,18",
    z900: "71,6,11"
  }
};
exports["default"] = _default;